import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Postdata } from "../../helpers/api.service";
import HttpService from "../../helpers/httpServices";
import { message } from "../../redux/actions/toastActions";
import Loader from "../../components/common/Loader";
import Title from "../../components/common/Title";
import { Topbar } from "../../components/include/Topbar";
import { isPermission, isRole, isRoleType } from "../../redux/selectors/authSelector";
import Error403Page from "../ErrorPage";
import { toast } from "sonner";
import { useCountryNavigate } from "../../components/common/UseCountryNavigate";

const Add_leadership = () => {
  const [errors, setErrors] = useState({});
  const [loader, setLoader] = useState(false);
  const [formData, setFormData] = useState({
    title: "",
    brief: "",
    detailed: "",
    image: "",
  });
  const location = useLocation();
  // const navigate = useNavigate();
  const navigate = useCountryNavigate();
  const params = useParams();
  const [previewURL, setPreviewURL] = useState(null);
  const dispatch = useDispatch();
  const [refresh, setRefresh] = useState(false);
  const permissions = useSelector(isPermission);
  const role = useSelector(isRole);
  const role_type = useSelector(isRoleType);

  const isAccessible =
    role === "admin" ||
    role === "subadmin" ||
    role == "schooladmin" ||
    (permissions && (permissions?.includes("edit_Extracurricular") || permissions?.includes("edit_School"))) ||
    false;
  const schoolId = localStorage.getItem("activeSchoolId");
  const mode = localStorage.getItem("mode");

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    const maxSize = 5 * 1024 * 1024; // 10MB

    if (!file) return;

    if (file.size > maxSize) {
      // setErrors((prev) => ({
      //     ...prev,
      //     image: "Image must be less than 10MB"
      // }));
      toast.warning("Image size must not exceed 5MB");

      e.target.value = "";
      return;
    }

    setErrors((prev) => ({ ...prev, image: "" }));
    setFormData((prev) => ({ ...prev, image: file }));
    setPreviewURL(URL.createObjectURL(file));
  };
  const validate = () => {
    const newErrors = {};
    if (!formData.title) newErrors.title = "Title is required";
    if (!formData.brief) newErrors.brief = "Brief description is required";
    if (!formData.detailed)
      newErrors.detailed = "Detailed description is required";

    // Image validation
    if (!formData.image && location.state?.type !== "edit") {
      newErrors.image = "Image is required";
    } else if (
      typeof formData.image !== "string" &&
      formData.image?.size > 10 * 1024 * 1024
    ) {
      newErrors.image = "Image must be less than 10MB";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoader(true);

    const form = new FormData();
    if (params.id) form.append("id", params.id);
    form.append("title", formData.title);
    form.append("brief", formData.brief);
    form.append("detailed", formData.detailed);
    form.append("school_id", schoolId);

    if (formData.image) {
      form.append("image", formData.image);
    }

    Postdata(HttpService.leadership_add, form).then((res) => {
      if (res.status === 200) {
        toast.success(res.message);
        if (role === "admin" || role === "subadmin" || role_type === "schoolsubadmin" || role_type === "subadmin") {
          if (mode === "view") {
            navigate(`admin-school/view/${schoolId}`, {
              state: { mainTab: "Extracurricular", currentTab: "Leadership" },
            });
          } else {
            navigate("navigation-dashboard", {
              replace: true,
              state: { mainTab: "Extracurricular", currentTab: "Leadership" },
            });
          }
        } else {
          navigate("extracurricular", {
            replace: true,
            state: { currentTab: "Leadership" },
          });
        }
      }
      // dispatch(message(res.message));
      setLoader(false);
    });
    console.log("Submitted as FormData:", formData);
  };

  const fetchData = () => {
    setLoader(true);
    Postdata(HttpService.leadership_show, {
      id: params.id,
      school_id: schoolId,
    }).then((res) => {
      if (res.status === 200) {
        setFormData({
          title: res.data.title,
          brief: res.data.brief,
          detailed: res.data.detailed,

          image: res.data.image,
        });
        setPreviewURL(res.data.image);
      }
      // else {

      //     dispatch(message(res.message));
      // }
      setLoader(false);
    });
  };

  useEffect(() => {
    if (location.state?.type === "edit") {
      fetchData();
    }
  }, []);

  if (loader) {
    return <Loader isClass="loader_fullscreen" />;
  }

  if (!isAccessible) {
    return <Error403Page />;
  }
  return (
    <div>
      <Title name=" Add Leadership" />
      <Topbar
        title={
          location.state?.type === "edit" ? "Edit Leadership" : "Add Leadership"
        }
        aerrow={true}
      />
      <div className="rounded-[20px]   m-4 ">
        {" "}
        {/* Added margin-bottom */}
        {/* Drag and Drop Area */}
        <div className=" border-gray-300 bg-white  relative rounded-lg  text-center text-gray-500 hover:border-gray-400 transition duration-300 ease-in-out">
          <input
            type="file"
            id="academic-calendar-upload"
            accept=".png,.jpg,.jpeg"
            className="hidden"
          />
          <label className="flex flex-col items-center justify-center  border-purple-500 cursor-pointer overflow-hidden">
            <input
              type="file"
              accept="image/*"
              onChange={handleImageUpload}
              className="hidden"
            />
            {console.log("previewURL", previewURL)}
            {previewURL ? (
              <div className=" relative h-[300px] w-full ">
                <img
                  src={previewURL || formData?.image}
                  alt="Preview"
                  className="w-full h-full object-cover rounded-xl "
                />
                <span className="text-white absolute top-[50%] left-[45%] z-10 font-medium">
                  + Upload Image
                </span>
              </div>
            ) : (
              <span className="text-primary_main p-[130px] rounded-xl font-medium">
                + Upload Image
              </span>
            )}
          </label>
        </div>
        {errors.image && (
          <span className="text-red-500 text-sm">{errors.image}</span>
        )}
        {/* Upload Button */}
        <form onSubmit={handleSubmit}>
          <div>
            <label className="block mb-1 font-medium text-gray-700">
              Leadership Title<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="title"
              placeholder="Enter Leadership Title"
              className="input-field"
              value={formData.title}
              onChange={handleInputChange}
              maxLength={50}
            />
            {errors.title && (
              <span className="text-red-500 text-sm">{errors.title}</span>
            )}
          </div>
          <div>
            <label className="block mb-1 font-medium text-gray-700">
              Brief Description<span className="text-red-500">*</span>
            </label>
            <textarea
              name="brief"
              placeholder="Write Here"
              className="input-field"
              value={formData.brief}
              onChange={handleInputChange}
            />
            {errors.brief && (
              <span className="text-red-500 text-sm">{errors.brief}</span>
            )}
          </div>
          <div>
            <label className="block mb-1 font-medium text-gray-700">
              Detailed Description<span className="text-red-500">*</span>
            </label>
            <textarea
              name="detailed"
              placeholder="Write Here"
              className="input-field"
              value={formData.detailed}
              onChange={handleInputChange}
            />
            {errors.detailed && (
              <span className="text-red-500 text-sm">{errors.detailed}</span>
            )}
          </div>
          <div className="w-full flex justify-center gap-3 mb-2 mt-4">
            <button
              type="submit"
              className="button-field-primary"
              style={{ width: "30%" }}
            >
              {loader ? "Please wait..." : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Add_leadership;
